
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/data-studio-services",
      function () {
        return require("private-next-pages/services/data-studio-services.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/data-studio-services"])
      });
    }
  